<template>
  <div class="form">

<v-card>
  <v-card-title class="text-h5 grey lighten-5">
  <v-breadcrumbs :items="item">
     <template v-slot:item="{ item }">
     <v-breadcrumbs-item
        :href="goToRoute(item.href)"
        :disabled="item.disabled"
      >
      {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
  </v-card-title>
</v-card>

<v-card>
  <v-card-title class="text-h5 grey lighten-2">
      {{ $t("modultangkapandataBlok7Imbangan") }}
  </v-card-title>

 <v-container>
      <v-form ref="formblok7Imbangan">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-bind:label="$t('hid')"
              outlined
              dense
              v-model="blok7Imbanganhid"
              :disabled="true"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="2">
            <v-text-field
              v-bind:label="$t('ps')"
              v-model="blok7Imbanganpusingan"
              outlined
              dense
              :disabled="true"
            ></v-text-field>
          </v-col>
        </v-row>

  <!-- DATATABLE  -->
  <v-card>
    <v-card-title >
      Senarai
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>

       <v-spacer></v-spacer>
        <v-btn
        color="error"
        small
        @click="dialogPengesahan=true;"
        >
          Padam BLOK7 IMBANGAN
           </v-btn>

    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataBlok7Imbangan"
      :search="search"
      class="ml-3 mr-3"
      @click:row="handleClick"
      :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
    ></v-data-table>
  </v-card>

  <v-card>
    <!-- <v-card-title> <strong>HELAIAN IMBANGAN </strong><br /> </v-card-title> -->
    <v-card-text >
      <v-form ref="form" v-model="valid" lazy-validation>

        <v-row>
          <v-col>
            <strong>PENERIMAAN BULAN SEMASA (INCS 09) </strong><br />
          </v-col>
        </v-row>

        <v-col> </v-col>

          <v-row>
             <v-col cols="20" sm="3" md="5">
            Nombor Isi Rumah </v-col>
            <v-col cols="1"><strong>[NOAIR]</strong><br /></v-col>
            <v-col cols="2">
            <v-autocomplete
                :items="senaraiIsiRumah"
                :item-text="item => item.NOAIR"
                return-object
                outlined
                dense
                v-model="selectNOAIR"
            ></v-autocomplete>
            </v-col>
          </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            (i). Wang yang dikeluarkan dari simpanan terdahulu
          

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Bank, Tabung Haji, Tabung Amanah  dan koperasi)</span>
          </v-tooltip>
            </v-col>
          <v-col cols="1"><strong>[INCS9a]</strong><br /></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="JUM9a"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            (ii) Jualan bon, saham dan jaminan<br />
          </v-col>

          <v-col cols="1"><strong>[INCS9b]</strong><br /></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="JUM9b"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            (iii) Pinjaman dari bank, koperasi dan orang perseorangan<br
          /></v-col>

          <v-col cols="1"> <strong>[INCS9c]</strong><br /></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="JUM9c"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            (iv) Sewa beli - pinjaman yang diperoleh<br
          /></v-col>

          <v-col cols="1"> <strong>[INCS9d]</strong><br /></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="JUM9d"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            (v) Penerimaan lain<br
          /></v-col>

          <v-col cols="1"> <strong>[INCS9e]</strong><br /></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="JUM9e"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

        <v-row>
          <v-col cols="20" sm="3" md="5">
            Jumlah penerimaan bulan semasa<br
          /></v-col>

          <v-col cols="1"><strong>[INCS09]</strong></v-col>
          <v-col cols="2">
            <v-text-field
              outlined
              dense
              v-model="INCS09"
              label="RM"
              required
              min="0"
              maxlength="7"
              hint="Sebulan"
              persistent-hint
              disabled
              @keypress="isNumber($event)"
            ></v-text-field
          ></v-col>
        </v-row>

         <v-row></v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
    <v-spacer></v-spacer>
  <v-btn
      text
      color="primary"
      @click='simpan()'
      v-show="butangSimpan"
      :disabled="!NOAIR"
  >
    Simpan
  </v-btn>
  <v-btn
    text
    color="primary"
    v-show="butangKemaskini"
    @click="updateIMBANGAN()"
  >
    Kemaskini
  </v-btn>
</v-card-actions>

  </v-card>

  <v-alert prominent type="error" :value="popUpALert">
    <v-row align="center" class="mb-2">
      <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
      <v-col class="shrink">
        <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
        <v-btn @click="padam('2')">Cancel</v-btn>
      </v-col>
    </v-row>
  </v-alert>

  <!-- Error Dialog -->
  <v-dialog v-model="errorDialog" width="500" height="200">
    <v-card>
      <v-alert dense outlined color="#C51162" type="error">
        <strong>{{ errMessage }}</strong>
      </v-alert>
    </v-card>
  </v-dialog>
   

  <!-- Success Dialog -->
  <v-dialog v-model="successDialog" width="500" height="200">
    <v-card color="success">
      <v-alert dense outlined color="#C51162" type="success">
        <strong>{{ successMessage }}</strong>
      </v-alert>
    </v-card>
  </v-dialog>
   </v-form>
</v-container>
</v-card>
      
        <!-- Pengesahan Padam Dialog -->
<v-row justify="center">
  <v-dialog
    v-model="dialogPengesahan"
    persistent
    max-width="330"
  >
    <v-card>
      <v-card-text>
       <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
       {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
       <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="warning"
          @click="dialogPengesahan = false;"
        >
         {{$t('batal')}}
        </v-btn>
        <v-btn
          color="error"
          @click="padamData()"
        >
          {{$t('padam')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-row>
    
</div>
</template>
<script>
import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import axios from "../../plugins/axios";
import i18n from "@/i18n";
/////////////////////////////////////////////////////////
import HES from '@/services/HES'
const HESservices= new HES();

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();
//////////////////////////end import services//////////////

import maklumatIsiRumah from '@/services/ringkasanMaklumatIsiRumah'
const servicesMaklumatIsiRumah = new maklumatIsiRumah();

export default {
Name: "Blok7Imbangan",
async beforeMount() {

//   //  if(!this.NOAIR){
//   //     var res = await publicServices.getBorangByHID(this.HID);//dapatkan data HID
//   //     this.publicHIDdata = res.data.data;
//   //     console.log(this.publicHIDdata)
//   // }

//   var dataHID = localStorageData.getHIDdata();

//   this.HID = dataHID.HID;
//   this.BNO = dataHID.BNO;
//   this.P = dataHID.P;
//   this.S = dataHID.S;
//   this.NG = dataHID.NG;
//   this.DP = dataHID.DP;
//   this.DB = dataHID.DB;
//   this.BP = dataHID.BP;
//   this.ST = dataHID.ST;
//   this.NOTK = dataHID.NOTK;
//   this.Bulan = dataHID.BULAN;
//   this.Tahun = dataHID.TAHUN;

 
//   //this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
//   //this.NOAIR = this.currNOAIRData.NOAIR;
  


   this.getData();//dapatkan data based on HID


},

data: () => ({
  blok7Imbanganhid:"",
  blok7Imbanganpusingan:"",
  updateButton: true,
  saveButton: false,
  dialog: false,
  successDialog: false,
  errorDialog: false,
  successMessage: "",
  errMessage: "",
  disabledInput : false,
  message: "Saving Data",
  popUpALert: false,
  search: "",
  butangSimpan: true,
  butangKemaskini: false,
  butangPadam: false,
  dialogPengesahan:false,

  /////////////////////data declaration//////////////////////////

  NOAIR: "",
  selectNOAIR:"",
  HID: "",
  JUM9a: 0,
  JUM9b: 0,
  JUM9c: 0,
  JUM9d: 0,
  JUM9e: 0,
  
  dataBlok7Imbangan: [],
  senaraiIsiRumah:[],
  
  headers: [
    {
      text: "NOAIR",
      align: "start",
      sortable: false,
      value: "NOAIR",
    },

   { text: "HID", value: "HID" },
    { text: "INCS 9a", value: "JUM9a" },
    { text: "INCS 9b", value: "JUM9b" },
    { text: "INCS 9c", value: "JUM9c" },
    { text: "INCS 9d", value: "JUM9d" },
    { text: "INCS 9e", value: "JUM9e" },
    { text: "INCS 09", value: "INCS09" },
  ],

  ///////////link untuk ke page/////////////////////
    item: [
    {
      text: "Paparan Utama",
      disabled: false,
      href: "paparanutama",
    },
    {
      text: "BLOK3 (PreCode)",
      disabled: false,
      href: "BLK3PreCode",
    },
    {
      text: "BLOK 3",
      disabled: false,
      href: "blk3",
    },
    {
      text: "BLOK 4a",
      disabled: false,
      href: "Blok4a",
    },
    {
      text: "BLOK 4b",
      disabled: false,
      href: "Blok4b",
    },
    {
      text: "BLOK 4c",
      disabled: false,
      href: "Blok4c",
    },
    {
      text: "BLOK 7",
      disabled: false,
      href: "blk7",
    },
    {
      text: "BLOK 7 (Imbangan)",
      disabled: true,
      href: "Blok7Imbangan",
    },
    {
      text: "Pengesahan (Imbangan)",
      disabled: false,
      href: "PengesahanImbangan",
    },
  ],
  valid: true,
  name: "",
  nameRules: [
    (v) => !!v || "Name is required",
    (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
  ],
  email: "",
  emailRules: [
    (v) => !!v || "E-mail is required",
    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
  ],
  rules: {
    required: (v) => !!v || "field is required",
    emel: (value) => {
      return /.+@.+\..+/.test(value) || "E-mail must be valid";
    },
    percentage: (value) => {
      return value <= 100 || "Percentage must between 1 - 100";
    },
    takmauPoint: (value) => {
      return value % 1 === 0 ? true : "No point needed";
    },
  },
  select: null,
  items: ["Item 1", "Item 2", "Item 3", "Item 4"],
  checkbox: false,
}),
mounted() {
  this.paparanpermulaan();
  if(!this.NOAIR){
    this.butangSimpan = false;
  }
  //this.tambahcatatan = "-";
},
methods: {
  goToRoute(url) {
    return `/${i18n.locale}/${url}/${this.$route.params.hid}`;
  },
  getUnits: function (a) {
    alert(`${a}`);
  },
  validate() {
    this.$refs.form.validate();
  },
  reset() {
    this.$refs.form.reset();
  },
  resetValidation() {
    this.$refs.form.resetValidation();
  },
  // kiraJUMLAH_B() {
  //   var total = 0;
  //   total = Number(this.INCS07P12) + Number(this.TOTINCS09);
  //   this.JUMLAH_B = total;
  // },
  // kiraTOT_C() {
  //   var total = 0;
  //   total = (Number(this.TOT_A) / Number(this.TOT_B)) * 100;
  //   this.TOT_C = total;
  // },
  
   async paparanpermulaan() {
    try {
      if (typeof this.$route.params.hid !== "undefined") {
        await axios
          .get(
            `${process.env.VUE_APP_API_URL}/auth/decode?de=${this.$route.params.hid}`
          )
          .then((result) => {
            this.blok7Imbanganhid = result.data.decode;
            const jr2 = {
              hidjr2: this.blok7Imbanganhid,
            };
            axios
              .post(`${process.env.VUE_APP_API_URL}/JR/papardatajr2`, jr2)
              .then((res) => {
               this.blok7Imbanganhid = res.data.data.HID;
               this.blok7Imbanganpusingan = res.data.data.P;
               this.getData();
                       
              });
             
          });

      } 
      // else {
      //   this.$router.push(`/${i18n.locale}/heshid`, () => {});
      // }
    } catch (err) {
      console.log(err);
      // if (err.response.data.msg === "errordecode") {
      //   this.$router.push(`/${i18n.locale}/heshid`, () => {});
      // }
    }

          if(!this.NOAIR){
              var irData = await servicesMaklumatIsiRumah.getMaklumatIsiRumahByHID(this.blok7Imbanganhid);
              this.senaraiIsiRumah = irData.dataJR5;
          }
  },

  async simpan() {
    // alert(this.blok7Imbanganhid)
    // alert(this.NOAIR)

      if (this.$refs.form.validate()) {
      this.dialog = true;
      setTimeout(() => (this.dialog = false), 2000);

      try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/blk/Blok7Imbangan`,
          {
            HID: this.blok7Imbanganhid,
            NOAIR: this.NOAIR,
            JUM9a: this.JUM9a,
            JUM9b: this.JUM9b,
            JUM9c: this.JUM9c,
            JUM9d: this.JUM9d,
            JUM9e: this.JUM9e,
            INCS09: this.INCS09,
            
          }
        );
        this.res = res.data;
        this.successDialog = true;
        this.disabledInput = true,
        setTimeout(() => (this.successDialog = false), 2000);
        this.successMessage = "Data Disimpan!";
        this.reset();
        this.getData();
        this.NOAIR = '';
        setTimeout(() => this.goTo(), 100);
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Simpan : " + error;
      }
    } else {
      window.scrollTo(0, 0);
      this.errorDialog = true;
      setTimeout(() => (this.errorDialog = false), 2000);
      this.errMessage = "Please fill in the field!";
    }
  },

  async updateIMBANGAN(){
          try {
              const res = await axios.post(`${process.env.VUE_APP_API_URL}/blk/updateBlok7Imbangan`, {
              
            HID: this.blok7Imbanganhid,
            NOAIR: this.NOAIR,
            JUM9a: this.JUM9a,
            JUM9b: this.JUM9b,
            JUM9c: this.JUM9c,
            JUM9d: this.JUM9d,
            JUM9e: this.JUM9e,
            INCS09: this.INCS09,
           
            })
              this.res = res.data;
              this.butangKemaskini = false;
              this.successDialog = true;
              // this.disabledInput = true, 
              this.getData();
              setTimeout(() => (this.successDialog = false), 2000);
              this.successMessage = 'Data Berjaya Dikemaskini!';
              this.NOAIR = '';
              this.reset();
              setTimeout(() => (this.goTo()), 1000);
              
          } catch (error) {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Simpan : '+error;
          }
    },


  async padam(val) {
    if (val == 0) {
      this.popUpALert = true;
    } else if (val == 1) {
      try {
        ///////////tunjukkan alert padam////////////
        // this.popUpALert = false;
        ////send delete to API///////
        if (this.$refs.form.validate()) {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/blk/deleteBlok7Imbangan`,
            {
              HID: this.blok7Imbanganhid,
              NOAIR: this.NOAIR,
            }
          );
          this.res = res.data;
          this.successDialog = true;
          setTimeout(() => (this.successDialog = false), 2000);
          this.successMessage = "Data Deleted!";
          this.saveButton = false;
          this.updateButton = true;
          this.NOAIR = '';
          this.reset();
          this.getData();
        } else {
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Please Fill In the field";
        }
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Padam : " + error;
      }
    } else if (val == 2) {
      this.popUpALert = false;
    }
  },
  
   async padamData(){

      try {
              const res = await axios.post(`${process.env.VUE_APP_API_URL}/blk/deleteBlok7Imbangan`, {
              HID: this.blok7Imbanganhid,
              NOAIR: this.NOAIR,
              table: "BLK_VII_IMBANG"
            })
              this.res = res.data;
              this.reset();
              this.dialogPengesahan = false;
              this.successDialog = true;
              this.NOAIR = '';
              setTimeout(() => (this.successDialog = false), 2000);
              this.successMessage = 'Data Dipadam!'
              this.getData(); 
            
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Padam : '+error;
          }  
    },

  async getData() {

    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/blk/Blok7Imbangan?HID=`+this.blok7Imbanganhid+`&NOAIR=`+this.NOAIR, {
        });
      var dataz = res.data.data;
      this.dataBlok7Imbangan = dataz;
    } catch (error) {
      //console.log(error)
      this.errorDialog = true;
      setTimeout(() => (this.errorDialog = false), 2000);
      this.errMessage = "getData : " + error;
    }
  },

  handleClick(row) {
    this.successDialog = true;
    this.successMessage = "Sila mulakan pengemaskinian!";
    setTimeout(() => (this.successDialog = false), 1000);

    this.butangSimpan = false;
    this.butangKemaskini = true;
    this.disabledInput = false;
    
    this.HID = row.HID;
    this.NOAIR = row.NOAIR;
    this.JUM9a = row.JUM9a;
    this.JUM9b = row.JUM9b;
    this.JUM9c = row.JUM9c;
    this.JUM9d = row.JUM9d;
    this.JUM9e = row.JUM9e;
    this.INCS09 = row.INCS09;
   
  },

  goTo() {
    this.$router.push({ name: `Blok7Imbangan/${this.$route.params.hid}` });
  },
  goBack() {
    this.$router.push({ name: "blk7" });
  },
   kiraINCS09() {
    var total = 0;
    total =
      Number(this.JUM9a) +
      Number(this.JUM9b) +
      Number(this.JUM9c) +
      Number(this.JUM9d) +
      Number(this.JUM9e);
    this.INCS09 = total;
  },
  
  isNumber($event) {
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
      // 46 is dot
      $event.preventDefault();
    }
  },
},
watch: {
  selectNOAIR(val){
    
    this.NOAIR = val.NOAIR;
    //console.log(this.NOAIR)
    this.getData();
  },
dataBlok7Imbangan() {
if(this.dataBlok7Imbangan.length > 0){
      this.butangSimpan = false;
      this.disabledInput = true;
    }else{
      this.butangSimpan = true;
      this.disabledInput = false;
    }
    }
},
computed: {
  INCS09: function () {
    var total = 0;
    total =
      Number(this.JUM9a) +
      Number(this.JUM9b) +
      Number(this.JUM9c) +
      Number(this.JUM9d) +
      Number(this.JUM9e);
      
    return total;
  },   
},


};
</script>



